
import {useMainStore} from "../stores/main";
import {storeToRefs} from "pinia";

let playing = {};

let arrTimeout = {};

export default function useSound ()
{




    function fadeOutAll (removeAfterFade = false)
    {
        for (let key in playing)
        {
            for (let obj of playing[key])
            {
                obj.sound.fade(obj.sound.volume() ?? 1, 0, 250);
            }
        }
    }

    function onStartTimeout (sound, callback)
    {
        sound.play();

        if (callback)
            callback();
    }
    function playSound(url, key, actions, callback )

    {
        //stopSound();

        let start = actions?.start ?? false;
        let end = actions?.end ?? false;

        if (!Array.isArray(playing[key]))
        {
            playing[key] = [];
        }

        stopPlaying(key);

        if (start && start.type === 'fade')
        {
            fadePlaying([key], start);
        }

        const sound = new Howl({
                                 src: [url],
                                    autoplay: false,
                                    loop: actions?.init?.loop ?? false,
                                 onend: () => onSoundEnd(key, sound, end, callback)
                             });

        if (actions?.delay > 0)
        {
            if (arrTimeout[key])
            {
                arrTimeout[key].forEach((timeout) => clearTimeout(timeout));
            }


            let id = setTimeout(() => onStartTimeout(sound, callback?.start ?? null), actions.delay);
            arrTimeout[key] = [id];
        }
        else
        {
            sound.play();
        }

        playing[key].push({sound, end, callback: callback?.end ?? null});

        //currentlyPlaying.value = sound;

        return sound;
    }

    function stopPlaying (key)
    {
        if (playing[key])
        {
            for (let obj of playing[key])
            {
                obj.sound.stop();
            }
        }
    }
    function onSoundEnd(key, sound, end, callback)
    {
        if (end && end.type === 'fade')
        {
            fadePlaying([key], end);

            if (callback?.end)
            {
                callback.end(true);
            }
        }

        if (end && end.type === 'stop')
        {
            sound.stop();

            if (callback?.end)
            {
                callback.end(true);
            }
        }

        if (end && end.type === 'loop')
        {
            sound.pause();
        }


    }

    function fadePlaying(except, action, callback)
    {
        for (let key in playing)
        {
            if (!except.includes(key))
            {
                for (let obj of playing[key])
                {
                    let s = obj.sound.volume();
                    obj.sound.fade(obj.sound.volume() ?? 1, action.to ?? 0, action.duration ?? 500);

                }
            }


        }
    }

        function fadeAndStopPlaying(which, action, callback)
        {
            for (let key in playing)
            {
                if (which.includes(key))
                {
                    for (let obj of playing[key])
                    {
                        let s = obj.sound.volume();
                        let duration = action?.duration ?? 500;
                        obj.sound.fade(obj.sound.volume() ?? 1, action?.to ?? 0, duration);

                        setTimeout(() => obj.sound.stop(), duration);


                    }
                }


            }
        }

        function stopSound()
        {
            // if (currentlyPlaying.value)
            // {
            //     currentlyPlaying.value.pause();
            //     currentlyPlaying.value.currentTime = 0;
            // }
        }


        function isAudioContextReady()
        {
            if (typeof AudioContext == undefined || typeof webkitAudioContext == undefined)
            {
                return false;
            }

            let audioContext = new (window.AudioContext || window.webkitAudioContext)();

            let acState = audioContext.state;

            console.log("isAudioContextReady", acState)

            return ["running"].includes(acState);
        }


        return {
            playSound,
            stopSound,
            stopPlaying,
            fadePlaying,
            fadeAndStopPlaying,
            fadeOutAll,
            isAudioContextReady
        }

}
